/* eslint-disable import/prefer-default-export */
export const MonetateEnums = Object.freeze({
  Product: 'index',
  Recipe: 'recipe',
  Story: 'story',
  Learn: 'learn',
  'Traeger TV': 'traegertv',
  Cart: 'cart',
  Ambassador: 'ambassador',
});
